export default __webpack_public_path__ + "static/ProValue_5@992-e2bff9b652e6d22715c4e725a58ee5ed.png";